module.exports = {"soutenir":{"title":"Apoio da Framasoft"},"title":"Início"};